/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsStaggeredProductsListViewProps } from '../../../modules/hosports-staggered-products-list/./hosports-staggered-products-list';
import StaggeredProductList from './../../../baseComponents/staggered-product-list/./staggered-product-list';

class StaggeredProductsListView extends React.Component<IHosportsStaggeredProductsListViewProps> {
  render() {
    const { config } = this.props;
    if(!config.products) return <span />
    return (
        <div className="secondary-background">
          <div className="max-width-container">
            <div className="row staggered-list">
              <StaggeredProductList
                productSlugArray={config.products}
                year={config.year}
              />
            </div>
          </div>
        </div>
    );
  }
}

export default StaggeredProductsListView;
